import Component from '../../lib/component'
import { RootComponent } from '../../main'
import { tabbable } from 'tabbable'

export default class GlobalHeaderComponent extends Component {
    static selector () {
        return '#global-header'
    }

    constructor (opts) {
        super(opts)

        this.addFeaturesToClassName()

        this.listen()
        this.render()
    }

    listen () {
        this.getMenuDropdowns()
            .forEach(el => {
                el.addEventListener('click',
                    this.dropdownToggle
                        .bind(this))

                el.addEventListener('mouseenter',
                    this.dropdownToggle
                        .bind(this))

                el.addEventListener('mouseleave',
                    this.dropdownToggle
                        .bind(this))
            })

        this.getMenuOverlayToggles()
            .forEach(el => {
                el.addEventListener('click',
                    this.onMenuOverlayToggleClick
                        .bind(this))

                el.addEventListener('keydown',
                    this.onMenuOverlayToggleKeydown
                        .bind(this))
            })

        this.el
            .addEventListener('keydown',
                this.onTabKeydown.bind(this))

        this.on('resize', (e) =>
            this.renderMenuOverlayIllustrations())
    }

    dropdownToggle (e) {
        const dropdown = e
            .target.closest('.dropdown')

        const dropdownBtn = dropdown
            .querySelector('.dropdown-button')

        const dropdownMenu = dropdown
            .querySelector('.dropdown-menu')

        const isSmallViewport = window.innerWidth < 992

        const isEventSmallViewport = (isSmallViewport
            && e.type === 'mouseenter')

        if (!dropdownBtn
            || !dropdownMenu
            || isEventSmallViewport)
            return

        const menuOpenCss = 'dropdown-open'

        const show = !dropdown.classList.contains(menuOpenCss)
            && e.type !== 'mouseleave'

        dropdown.classList[show
            ? 'add'
            : 'remove'](menuOpenCss)

        dropdownMenu
            .setAttribute('aria-hidden', !show)

        dropdownBtn
            .setAttribute('aria-expanded', show)

        if (isSmallViewport) {
            const overflowDisable = !document.documentElement
                .classList.contains('overflow-hidden')
            && show

            RootComponent.emit(`scroll:${overflowDisable
                ? 'disable'
                : 'enable'}`)
        }
    }

    onMenuOverlayToggleClick (e) {
        const target = e.target.getAttribute('aria-controls')
            ? e.target
            : e.target.parentNode.getAttribute('aria-controls')
                ? e.target.parentNode
                : null

        const controls = target
                && target.getAttribute('aria-controls')
            ? this.el.querySelector(`#${target.getAttribute('aria-controls')}`)
            : null

        if (!controls)
            return

        this.props.menuOverlayExpanded = !this.isMenuOverlayExpanded()
        this.render()
    }

    onMenuOverlayToggleKeydown (e) {
        if (e.keyCode === 32
                || (e.keyIdentifier || e.key || '').match(/^(enter)$/i))
            this.onMenuOverlayToggleClick(e)
    }

    onTabKeydown (e) {
        if (!(e.keyIdentifier || e.key || '').match(/tab/i)
                || !this.isMenuOverlayExpanded())
            return

        const els = tabbable(this.el)

        let activeEl

        if (e.shiftKey
                && els.indexOf(e.target) === 0)
            activeEl = els[els.length - 1]

        if (!e.shiftKey
                && els.indexOf(e.target) === els.length - 1)
            activeEl = els[0]

        if (!activeEl)
            return

        e.preventDefault()
        e.stopPropagation()

        activeEl.focus()
    }

    isMenuOverlayExpanded () {
        return this.props.menuOverlayExpanded === 'true'
    }

    getMenuDropdowns () {
        return Array.from(this.el
            .querySelectorAll('.global-header-menu-primary-nav .dropdown'))
    }

    getMenuOverlay () {
        return this.el.querySelector('#global-header-menu-overlay')
    }

    getMenuOverlayToggles () {
        return Array.from(this.el
            .querySelectorAll('.global-header-menu-overlay-toggle'))
    }

    setSiblingAriaHiddenAttr () {
        Array.from((RootComponent.el || {}).children)
            .filter(el => !el.tagName.match(/script/i)
                && el !== this.el)
            .forEach(el => el.setAttribute('aria-hidden',
                this.isMenuOverlayExpanded()
                    && el.getAttribute('aria-hidden') !== 'true'))
    }

    renderMenuOverlayToggles () {
        if (!this.getMenuOverlay())
            return

        this.getMenuOverlayToggles()
            .forEach(el => {
                if (!el.getAttribute('tabindex'))
                    el.setAttribute('tabindex', 0)

                if (el.getAttribute('aria-controls')
                        !== (this.getMenuOverlay().id || '')
                            .replace(/^#/, ''))
                    el.setAttribute('aria-controls',
                        (this.getMenuOverlay().id || '')
                            .replace(/^#/, ''))

                if (el.getAttribute('aria-expanded')
                        !== this.props.menuOverlayExpanded)
                    el.setAttribute('aria-expanded',
                        this.props.menuOverlayExpanded || false)

                let label

                if (el.getAttribute('data-aria-label-collapsed')
                        && this.props.menuOverlayExpanded !== 'true')
                    label = el.getAttribute('data-aria-label-collapsed')
                else if (el.getAttribute('data-aria-label-expanded')
                        && this.props.menuOverlayExpanded === 'true')
                    label = el.getAttribute('data-aria-label-expanded')

                if (label)
                    el.setAttribute('aria-label', label)
            })
    }

    renderMenuOverlayIllustrations () {
        if (!this.getMenuOverlay() || !this.isMenuOverlayExpanded())
            return

        const illustrationWrapper = this.el
            .querySelector('.global-header-menu-overlay-illustration-wrapper')

        const illustration = this.el
            .querySelector('.global-header-menu-overlay-illustration')

        if (!illustrationWrapper || !illustration) {
            this.props.menuOverlayIllustrationDisabled = true
            return
        }

        const isDisabled = illustrationWrapper.clientHeight
            < illustration.clientHeight

        if (this.props.menuOverlayIllustrationDisabled === String(isDisabled))
            return

        this.props.menuOverlayIllustrationDisabled = String(isDisabled)
    }

    render () {
        this.setSiblingAriaHiddenAttr()
        this.renderMenuOverlayToggles()
        this.renderMenuOverlayIllustrations()

        if (this.isMenuOverlayExpanded()
                && !document.documentElement
                    .classList.contains('overflow-hidden'))
            RootComponent.emit('scroll:disable')
        else if (document.documentElement.classList
            .contains('overflow-hidden')
                && !this.isMenuOverlayExpanded())
            RootComponent.emit('scroll:enable')

        // Edge-case Apple Webkit bug
        const gearSVG = this.el.querySelector('.logo-client-handbook svg')

        const isSafariMac = this.getBrowser('name') === 'safari'
            && this.getBrowser('os').match(/^mac/i)

        if (!gearSVG
                || (!isSafariMac
                        && this.getBrowser('name') !== 'ios'))
            return

        gearSVG
            .setAttribute('style', 'animation: none; -webkit-animation: none;')

        setTimeout(() => gearSVG
            .removeAttribute('style'), 1)
    }
}
